import gql from "graphql-tag";

export const REVIEW_CREATE = gql`
  mutation reviewCreate($input: ReviewInput!) {
    reviewCreate(input: $input) {
      errors {
        field
        message
      }
      productReview {
        id
      }
    }
  }
`;

export const REVIEW_IMAGES_CREATE = gql`
  mutation reviewImagesCreate($input: ReviewImagesCreateInput!) {
    reviewImagesCreate(input: $input) {
      errors {
        field
        message
      }
    }
  }
`;
